import { emptyAddress } from './address';
import { emptyUser } from './user';

export type OneDayCodeListResponse =
	Components.Responses.OneDayCodeListResponse;

export type OneDayCodeResponse = Components.Responses.OneDayCodeResponse;

export type OneDayCodeGen3 = Components.Schemas.OneDayCodeGen3;
export type BigIntId = Components.Schemas.BigIntId;
export type Device = Components.Schemas.Device;
export type User = Components.Schemas.User;
export type UtcDate = Components.Schemas.UtcDate;
export type UtcDateTime = Components.Schemas.UtcDateTime;
export type FirstName = Components.Schemas.FirstName;
export type LastName = Components.Schemas.LastName;
export type Email = Components.Schemas.Email;
export type Address = Components.Schemas.Address;
export type OneDayCode = Components.Schemas.OneDayCode;
export type OneDayCodeReason = Components.Schemas.OneDayCodeReason;

export const emptyOneDayCodeGen3 = (): OneDayCodeGen3 => ({
	id: '',
	deviceId: '',
	oneDayCode: '',
	reason: '',
	creatorId: '',
	creatorCompanyId: '',
	creator: emptyUser(),
	utcCreateDate: '',
	utcValidDate: '',
	firstName: '',
	lastName: '',
	email: '',
	mobilePhoneNumber: '',
	propertyName: '',
	deviceLocation: '',
	address: emptyAddress(),
});
